export const panDetailsFormFields = [
  {
    type: 'text',
    name: 'panNumber',
    label: 'Enter PAN',
    placeholder: 'Eg: NVLNK4546',
    maxLength: 10,
    autoCapitalize: 'characters',
    config: {
      required: true,
    },
  },
  {
    type: 'date',
    name: 'dob',
    label: 'Date of Birth',
    value: new Date(),
    config: {
      required: true,
      maxDate: new Date(),
    },
  },
]
